// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p9-1";
export var stateContainer = "_p9-0";